// extracted by mini-css-extract-plugin
export default {"label__link":"label_label__link__D41xd"};